import React, {
	Context,
} from 'react';
import Socket from '../connection/socket';

export interface SocketInterface {
	socket: Socket | null;
}

export const SocketContext = React.createContext({
	socket: null,
}) as Context<SocketInterface>;

export const SocketProvider = (
	props: any,
): React.ReactElement<any, React.Provider<SocketInterface>> => (
	<SocketContext.Provider value={{ socket: props.socket }}>
		{props.children}
	</SocketContext.Provider>
);
